<app-popin-container [hasPadding]="false" class="relative">
  <div>
    <div class="grid grid-cols-1 desk:grid-cols-[715px_auto] desk:px-10 desk:py-[90px]">
      <div class="relative mt-[-22px] h-64 overflow-hidden desk:mt-0 desk:h-[477px] desk:rounded-[20px]">
        <app-image [image]="selectedImage()" [isPriority]="true" />
        @if (nImages() > 1) {
          <div class="absolute inset-0 flex items-center justify-between p-6 text-white">
            <app-svg
              (click)="onMoveToImage('prev')"
              [height]="33"
              [inline]="true"
              [width]="16"
              class="rotate-180 cursor-pointer"
              src="assets/icons/caret-right.svg" />
            <app-svg
              (click)="onMoveToImage('next')"
              [height]="33"
              [inline]="true"
              [width]="16"
              class="cursor-pointer"
              src="assets/icons/caret-right.svg" />
          </div>
        }
      </div>
      <div class="flex flex-col justify-between gap-4 p-6 desk:p-0 desk:pl-5">
        @if (selectedProject(); as selectedProject) {
          <div class="title-custom-47 w-5/6 font-title desk:w-full">
            {{ selectedProject.name }}
          </div>
          <div [innerHTML]="selectedProject.kitchenerNote" class="grow"></div>
          <div class="rounded-[20px] bg-gray-light px-4 py-[19px]">
            <span class="font-[500] leading-[19px]">{{
              "COMPONENT.POPIN-REALISATIONS-CLIENTS.CREATED_BY" | translate
            }}</span>
            <app-title [title]="selectedProject.createdBy" size="custom-35-device-agnostic" />
          </div>
        }
      </div>
    </div>
    <div class="bottom-0 flex w-full justify-between gap-5 p-6 desk:absolute desk:px-10">
      <button (click)="onMoveToProject('prev')" class="flex cursor-pointer items-center gap-3">
        <div class="drop-shadow-custom flex size-9 min-w-9 items-center justify-center rounded-[11px] bg-anis">
          <app-svg [width]="24" class="rotate-180" src="assets/icons/arrow-right.svg" />
        </div>
        <span class="text-left font-bold">{{
          "COMPONENT.POPIN-REALISATIONS-CLIENTS.PREVIOUS_KITCHEN" | translate
        }}</span>
      </button>
      <button (click)="onMoveToProject('next')" class="flex cursor-pointer items-center gap-3">
        <span class="text-end font-bold">{{ "COMPONENT.POPIN-REALISATIONS-CLIENTS.NEXT_KITCHEN" | translate }}</span>
        <div class="drop-shadow-custom flex size-9 min-w-9 items-center justify-center rounded-[11px] bg-anis">
          <app-svg [width]="24" src="assets/icons/arrow-right.svg" />
        </div>
      </button>
    </div>
  </div>
</app-popin-container>
